// Shared theme configuration for both Mantine and Tailwind
export const sharedTheme = {
  colors: {
    customBlue: [
      '#e6f7f9', // 0 - lightest
      '#cceff3', // 1
      '#99dfeb', // 2
      '#66cfe3', // 3
      '#33bfdb', // 4
      '#2594a9', // 5 - main brand color
      '#2594a9', // 6
      '#1e7a8a', // 7
      '#17606b', // 8
      '#10464c', // 9 - darkest
    ],
    customOrange: [
      '#fef2ed', // 0 - lightest
      '#fde5d6', // 1
      '#fbcbad', // 2
      '#f9b184', // 3
      '#f7975b', // 4
      '#f05a22', // 5 - main brand color
      '#f05a22', // 6
      '#d14a1c', // 7
      '#b23a16', // 8
      '#932a11', // 9 - darkest
    ],
    // Standard colors that both frameworks can use
    gray: [
      '#f8f9fa', // 0
      '#e9ecef', // 1
      '#dee2e6', // 2
      '#ced4da', // 3
      '#adb5bd', // 4
      '#6c757d', // 5
      '#495057', // 6
      '#343a40', // 7
      '#212529', // 8
      '#000000', // 9
    ],
    white: '#ffffff',
    black: '#000000',
  },
  fonts: {
    sans: "'Roboto', -apple-system, sans-serif",
    mono: "'Monaco', 'Courier New', monospace",
  },
  fontSizes: {
    xs: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    base: '1rem', // 16px
    lg: '1.125rem', // 18px
    xl: '1.25rem', // 20px
    '2xl': '1.5rem', // 24px
    '3xl': '1.875rem', // 30px
    '4xl': '2.25rem', // 36px
  },
  spacing: {
    0: '0',
    1: '0.25rem', // 4px
    2: '0.5rem', // 8px
    3: '0.75rem', // 12px
    4: '1rem', // 16px
    5: '1.25rem', // 20px
    6: '1.5rem', // 24px
    8: '2rem', // 32px
    10: '2.5rem', // 40px
    12: '3rem', // 48px
    16: '4rem', // 64px
    20: '5rem', // 80px
    24: '6rem', // 96px
    'text-card-spacing': '50px',
  },
  borderRadius: {
    none: '0',
    sm: '0.125rem', // 2px
    base: '0.25rem', // 4px
    md: '0.375rem', // 6px
    lg: '0.5rem', // 8px
    xl: '0.75rem', // 12px
    '2xl': '1rem', // 16px
    '3xl': '1.5rem', // 24px
    full: '9999px',
  },
  breakpoints: {
    xs: '576px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
    xl: '1400px',
  },
} as const;
